<template>
  <br />
  <label class="form-check-label" :for="keyId"> {{ placeholder }} </label>
  <br />
  <div class="row" v-for="(item, index) in model.keys" :key="index">
    <div :class="classLarge">
      <InputCheckbox
        class=""
        :keyId="`${item}-${index}`"
        :placeholder="getLabel(item)"
        :model="getData(item)"
        type="checkbox"
        :disabled="disabled"
      ></InputCheckbox>
    </div>
  </div>
</template>
<script setup lang="ts">
import { defineProps, computed, ref } from "vue";
import { defineEmits } from "@vue/runtime-core";
import InputCheckbox from "@/features/shared/components/form/InputCheckbox.vue";
import { useStore } from "vuex";
import * as dtos from "@/models/dtos";
const store = useStore();

const classSmall = "col-sm-5 col-md-5";
const classLarge = "col-sm-7 col-md-7";
const props = defineProps<{
  model: dtos.DynamicPropertyGroupItem;
  keyId: string;
  placeholder: string;
  full: any;
  disabled: boolean;
}>();

function getLabel(item: string) {
  const prop = store.getters.getformBuilderAllItems.find((px) => {
    return px.key == item;
  });
  return prop.label;
}

function getData(item: string) {
  const prop = store.getters.getformBuilderAllItems.find((px) => {
    return px.key == item;
  });
  return prop.data;
}
let model = ref(props.model);
</script>
<style></style>
